import { useAppSelector } from "@/state/hooks";
import { useCallback, useEffect, useState } from "react";
import { getUserInfo, getProcessInfo } from "./api";
import { useDispatch } from "react-redux";
import { updateKycInfo } from "@/state/kyc";
import { updateUserInfo } from "@/state/user/reducer";
import { usePersonalHooks } from "@/pages/accountManager/hooks";

const useCommonHooks = () => {
  const dispatch = useDispatch();

  const fetchGetProcessInfo = async () => {
    const res = await getProcessInfo({});
    if (res.code === 0) {
      dispatch(updateKycInfo(res.data.process));
    }
  };

  const getUserInfoFn = async () => {
    const res = await getUserInfo({});
    if (res.code === 0) {
      dispatch(updateUserInfo({ userInfo: res.data }));
    }
  };

  useEffect(() => {
    fetchGetProcessInfo();
    getUserInfoFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const useCertificate = () => {
  const { userInfo } = usePersonalHooks();
  const kycInfo = useAppSelector((state) => state.kyc.kycInfo);
  const [processData, setProcessData] = useState([]);
  const [baseBtnInfo, setBaseBtnInfo] = useState();
  const [evaBtnInfo, setEvaBtnInfo] = useState();
  const [verifyBtnInfo, sertVerifyBtnInfo] = useState();
  const [verifyType, setVerifyType] = useState("");
  // const [c3Process, setC3Process] = useState([]);

  useEffect(() => {
    if (kycInfo?.length) {
      // console.log("[[kycInfo]]", kycInfo);
      // c3中 只要有一个状态时DENIED 整个流程都停了
      // setC3Process([
      //   kycInfo[0],
      //   kycInfo[1],
      //   kycInfo[2],
      //   kycInfo[4],
      //   kycInfo[5],
      //   kycInfo[7],
      // ]);
      getBaseBtnInfo(
        kycInfo[0],
        kycInfo[1],
        kycInfo[2],
        kycInfo[3],
        kycInfo[4],
        kycInfo[8]
      );
      getEvalBtnInfo(kycInfo[3], kycInfo[6], kycInfo[7], kycInfo[8]);
      getVerifyBtnInfo(kycInfo[3], kycInfo[6], kycInfo[8]);

      const result = [];
      for (let i = 0; i < kycInfo.length; i++) {
        if (i === 0) {
          const { status } = kycInfo[0];
          result.push({
            ...kycInfo[0],
            textColor:
              status === "REQUIRED"
                ? getTextColor("gray")
                : status === "APPROVED"
                ? getTextColor("blue")
                : getTextColor("black"),
            imgActive: true,
          });
        }

        if (i === 5 || i === 8) {
          // 看第四步状态
          const stepFourStatus = kycInfo[i === 5 ? 3 : 6];
          const currStatus = kycInfo[i];
          let pararms = {};
          if (currStatus.status === "APPROVED") {
            pararms = {
              textColor: getTextColor("blue"),
              imgActive: true,
            };
          } else {
            if (
              stepFourStatus.status === "APPROVED" ||
              stepFourStatus.status === "PENDING"
            ) {
              pararms = {
                textColor: getTextColor("black"),
                imgActive: true,
              };
            }
          }
          result.push({
            ...kycInfo[i],
            ...pararms,
          });
        }

        if (i === 4 || i === 7 || i === 8) {
          //  5、8、9 选填的只看当前状态
          const currStatus = kycInfo[i];
          let pararms = {};
          if (currStatus.status === "APPROVED") {
            pararms = {
              textColor: getTextColor("blue"),
              imgActive: true,
            };
          } else if (currStatus.status === "REQUIRED") {
            pararms = {
              textColor: getTextColor("gray"),
              imgActive: false,
            };
          } else {
            pararms = {
              textColor: getTextColor("black"),
              imgActive: false,
            };
          }
          result.push({
            ...kycInfo[i],
            ...pararms,
          });
        }

        if (i === 1 || i === 2 || i === 3 || i === 6) {
          // 2、3、4、7 需要看前一个状态
          let pararms = {};
          const prevStatus = kycInfo[i - 1];
          const currStatus = kycInfo[i];
          if (currStatus.status === "APPROVED") {
            pararms = {
              textColor: getTextColor("blue"),
              imgActive: true,
            };
          } else {
            if (prevStatus.status === "APPROVED") {
              pararms = {
                imgActive: true,
                textColor: getTextColor("black"),
              };
            } else {
              pararms = {
                imgActive: false,
                textColor: getTextColor("gray"),
              };
            }
          }
          result.push({
            ...kycInfo[i],
            ...pararms,
          });
        }
      }
      setProcessData(result);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kycInfo]);

  useEffect(() => {
    if (userInfo.auth_mode) {
      setVerifyType(userInfo.auth_mode === "bank_transfer" ? "bank" : "other");
    }
  }, [userInfo.auth_mode]);

  useEffect(() => {
    // 默认
    if (verifyBtnInfo?.isActive) {
      setVerifyType("bank");
    }
  }, [verifyBtnInfo?.isActive]);

  const getTextColor = (type) => {
    const maps = {
      blue: "#333BF5",
      black: "#010313",
      gray: "#7B7C8F",
    };
    return maps[type];
  };

  const getSelfBtnInfo = useCallback((type) => {
    const maps = {
      DENIED: {
        text: "gyneoIYPeiHgfaCY",
        isActive: false,
      },
      APPROVED: {
        text: "zZXyblLWbONMNIjPmBN",
        isActive: true,
      },
      PENDING: {
        text: "hfBBkSOAXqfEsLVFs",
        isActive: false,
      },
      REQUIRED: {
        text: "dpnyHVmjzJjiqtQIfpD",
        isActive: false,
      },
    };
    return maps[type];
  }, []);

  const getBaseBtnInfo = (
    stepOneInfo,
    stepTwoInfo,
    setpThreeInfo,
    stepFourInfo,
    stepFiveInfo,
    nineInfo
  ) => {
    const text = getSelfBtnInfo(stepFourInfo.status).text;

    let isActive;

    if (stepOneInfo.status === "REQUIRED") {
      isActive = true;
    } else if (stepTwoInfo.status === "REQUIRED") {
      isActive = true;
    } else if (setpThreeInfo.status === "REQUIRED") {
      isActive = true;
    } else if (
      stepFourInfo.status === "DENIED" ||
      nineInfo.status === "DENIED"
    ) {
      isActive = false;
    } else if (
      stepFourInfo.status !== "DENIED" &&
      stepFiveInfo.status === "REQUIRED"
    ) {
      isActive = true;
    } else if (
      stepFourInfo.status !== "DENIED" &&
      stepFiveInfo.status !== "REQUIRED"
    ) {
      isActive = false;
    }

    setBaseBtnInfo({
      isActive,
      text,
    });
  };

  const getEvalBtnInfo = (fourInfo, sevenInfo, eightInfo, nineInfo) => {
    const text =
      sevenInfo.status === "REQUIRED"
        ? getSelfBtnInfo("REQUIRED").text
        : sevenInfo.status === "APPROVED"
        ? getSelfBtnInfo("APPROVED").text
        : "";

    let isActive = "";
    if (
      fourInfo.status === "DENIED" ||
      fourInfo.status === "REQUIRED" ||
      nineInfo.status === "DENIED"
    ) {
      isActive = false;
    }
    // if (sevenInfo.status === '')
    if (fourInfo.status === "APPROVED" || fourInfo.status === "PENDING") {
      isActive = true;
      if (eightInfo.status !== "REQUIRED") {
        isActive = false;
      }
    }

    setEvaBtnInfo({
      isActive,
      text,
    });
  };

  const getVerifyBtnInfo = (fourInfo, sevenInfo, nineInfo) => {
    let text = getSelfBtnInfo(nineInfo.status).text;
    let isActive = false;

    if (
      fourInfo.status === "DENIED" ||
      fourInfo.status === "REQUIRED" ||
      sevenInfo.status === "DENIED" ||
      sevenInfo.status === "REQUIRED"
    ) {
      isActive = false;
    }
    if (fourInfo.status === "APPROVED" && sevenInfo.status === "APPROVED") {
      isActive = true;

      if (
        nineInfo.status === "APPROVED" ||
        nineInfo.status === "DENIED" ||
        nineInfo.status === "PENDING"
      ) {
        isActive = false;
      }
    }

    sertVerifyBtnInfo({
      isActive,
      text,
    });
  };

  const getVerifyType = (type) => {
    if (verifyBtnInfo?.isActive && type !== verifyType) {
      setVerifyType(type);
    }
  };

  return {
    baseBtnInfo,
    verifyBtnInfo,
    evaBtnInfo,
    processData,
    verifyType,
    getTextColor,
    getVerifyType,
  };
};

export { useCertificate, useCommonHooks };
